import { css } from 'linaria';

// Reusable across Linaria styled templates (raw CSS string, not a generated class)
export const elementPressAnimation = css`
  &:active {
    animation: elevatePress 140ms ease-out;
  }
  --press-scale: 0.985;
  --press-translate-y: 1px;
  --press-brightness: 0.98;

  @keyframes elevatePress {
    0% {
      transform: translateY(0) scale(1);
      filter: brightness(1);
    }

    100% {
      transform: translateY(var(--press-translate-y)) scale(var(--press-scale));
      filter: brightness(var(--press-brightness));
    }
  }
`;
